import { Injectable } from '@angular/core';
import { EnvironmentConfigService } from '../../core/config/environment-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../authentication/authentication.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Notification } from '../../interfaces/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private httpClient: HttpClient,
    private environmentConfig: EnvironmentConfigService,
    private authenticationService: AuthenticationService
  ) { }

  headers = new HttpHeaders()
    .set('content-type', 'application/json');

  private notificationsSubject = new BehaviorSubject<Notification[]>([]);
  public notificationsObservable: Observable<Notification[]> = this.notificationsSubject.asObservable();

  getNotifications() {
    this.authenticationService.getIdToken().then(idToken => {
      if (typeof idToken === 'string') {
        let httpHeaders = new HttpHeaders()
          .set('content-type', 'application/json')
          .set('Authorization', idToken);

        this.httpClient.get<Notification[]>(`${this.environmentConfig.apiUrl}/notifications`, {headers: httpHeaders})
          .subscribe({
            next: data => {
              this.notificationsSubject.next(data);
            },
            error: err => {
              console.log(err);
            }
          });
      }
    });
  }

  createNotification(notification: Notification) {
    return new Promise<Notification>((resolve, reject) => {
      this.authenticationService.getIdToken().then(idToken => {
        if (typeof idToken === 'string') {
          let httpHeaders = new HttpHeaders()
            .set('content-type', 'application/json')
            .set('Authorization', idToken);

          this.httpClient.post<Notification>(`${this.environmentConfig.apiUrl}/notifications`,
            notification,
            {'headers': httpHeaders})
            .subscribe({
              next: data => {
                resolve(data);
              },
              error: (error) => {
                console.error('Failed to create notification:', error);
                reject(error);
              },
              complete: () => {
                this.getNotifications();
              }
            });
        }
      });
    });
  }

  updateNotification(notification: Notification) {
    return new Promise<Notification>((resolve, reject) => {
      this.authenticationService.getIdToken().then(idToken => {
        if (typeof idToken === 'string') {
          let httpHeaders = new HttpHeaders()
            .set('content-type', 'application/json')
            .set('Authorization', idToken);

          this.httpClient.put<Notification>(`${this.environmentConfig.apiUrl}/notifications/${notification.id}`,
            notification,
            {'headers': httpHeaders})
            .subscribe({
              next: data => {
                resolve(data);
              },
              error: (error) => {
                console.error('Failed to update notification:', error);
                reject(error);
              },
              complete: () => {
                this.getNotifications();
              }
            });
        }
      });
    });
  }

  deleteNotification(notificationId: string) {
    return new Promise<void>((resolve, reject) => {
      this.authenticationService.getIdToken().then(idToken => {
        if (typeof idToken === 'string') {
          let httpHeaders = new HttpHeaders()
            .set('content-type', 'application/json')
            .set('Authorization', idToken);

          this.httpClient.delete<void>(`${this.environmentConfig.apiUrl}/notifications/${notificationId}`,
            {'headers': httpHeaders})
            .subscribe({
              next: () => {
                resolve();
              },
              error: (error) => {
                console.error(`Failed to delete notification ${notificationId}:`, error);
                reject(error);
              },
              complete: () => {
                this.getNotifications();
              }
            });
        }
      });
    });
  }
}
